import { styled } from "@mui/material/styles";
import { Box, Paper } from "@mui/material";

export const SettingsCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: 8,
}));

export const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const TimeRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  marginTop: theme.spacing(1.5),
}));
